import { httpHandler } from '../httpHandler';

export const getDashboard = () => httpHandler.get({url: `/w/seller/dashboard`});
export const getComission = () => httpHandler.get({url: `/w/seller/commission`});
export const getRewardSettings = () => httpHandler.get({url: `/seller/reward/settings`});
export const getCompany = (body) => httpHandler.get({url: `/w/seller/company`, params: body});
export const getModules = () => httpHandler.get({url: `/w/seller/modules` });